module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/rydb1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Frydb1.png
// module id = NozA
// module chunks = 93